import { FC } from 'react'
import { FilterMuscleItem } from '@pages/TrainingConstructor/ui/filter/filterCatalog'

type FilterMuscleCardProps = {
	muscle: FilterMuscleItem
	isSelected?: boolean
	isReadonly?: boolean
	onToggle?: () => void
	className?: string
}

export const FilterMuscleCard: FC<FilterMuscleCardProps> = ({
	muscle,
	isSelected = false,
	isReadonly = false,
	onToggle,
	className = '',
}) => {
	const classNames = [
		'training-filter-muscle-card',
		isSelected ? 'is-selected' : '',
		isReadonly ? 'is-readonly' : '',
		className,
	]
		.filter(Boolean)
		.join(' ')

	if (isReadonly) {
		return (
			<div className={classNames} aria-label={muscle.title}>
				<span className="training-filter-muscle-image">
					<img src={muscle.icon} alt="" />
				</span>
				<span className="training-filter-muscle-title">{muscle.title}</span>
			</div>
		)
	}

	return (
		<button
			type="button"
			className={classNames}
			aria-pressed={isSelected}
			onClick={onToggle}
		>
			<span className="training-filter-muscle-image">
				<img src={muscle.icon} alt="" />
			</span>
			<span className="training-filter-muscle-title">{muscle.title}</span>
		</button>
	)
}
